import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import HelpPageComponent from './HelpPageComponent';
import actions from './actions/faq';

import coreActions from '../core/actions';

const allActions = { ...coreActions, ...actions };

const mapStateToProps = (state) => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(HelpPageComponent);
